/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import Button from '@mui/material/Button';
import CardHeader from 'components/Card/Header';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import CardActions from 'components/Card/Actions';
import DeleteAccountModal from '../Settings/DeleteAccountModal';

const styles = {
  card: {
    padding: 2,
    overflow: 'auto',
    marginBottom: 10,
  },
  cardLayout: {
    borderRadius: 15,
    backgroundColor: '#FFFFFF',
    textAlign: 'center',
    padding: '20px 50px',
  },
  cardText: {
    color: '#000',
    paddingBottom: 24,
  },
  button: {
    borderRadius: 15,
    backgroundColor: '#0076BB',
    color: '#FFFFFF',
  },
  buttonRed: {
    borderRadius: 15,
    backgroundColor: '#EF493E',
    color: '#FFFFFF',
  },
  left: {
    width: '5%',
  },
  cardActions: {
    display: 'inline-flex',
    paddingBottom: 24,
  },
  dint: {
    fontFamily: 'jost',
    fontWeight: 400,
    fontSize: '16px',
    textAlign: 'center',
    marginBottom: '6%',
    marginTop: '6%',
    color: '#424141',
  },
  resend: {
    color: 'blue',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontWeight: '600',
  },
  createAccount: {
    color: '#080808',
    fontSize: '24px',
    textAlign: 'center',
    fontWeight: '700',
    fontFamily: 'NewOrderBold',
    marginBottom: '4%',
  },
  descriptionNew: {
    fontFamily: 'jost',
    fontSize: '16px',
    lineHeight: '20px',
    textAlign: 'center',
    marginBottom: '5%',
    color: '#656565',
  },
  errortext: {
    fontFamily: 'NewOrderBold',
    fontSize: '18px',
    textAlign: 'center',
    marginBottom: '5%',
    color: '#EF493E',
    marginTop: '6%',
  },
  buttonOrange: {
    marginLeft: '10px',
  },
  listItemRow: {
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },
  listItemTextWrapper: {
    flex: 1,
    minWidth: 0,
    marginRight: 16,
  },
  buttonWrapper: {
    marginTop: 8,
    minWidth: 120,
    display: 'flex',
    justifyContent: 'flex-end',
  },
};

const DeleteAccount = () => {
  const [isDelete, setIsDelete] = useState(false);
  return (
    <>
      <DeleteAccountModal isDelete={isDelete} setIsDelete={setIsDelete} />
      <CardHeader
        title='Manage Ripple Street Account'
        titleStyle={styles.cardHeaderTile}
      />
      <List style={styles.list}>
        <ListItem key='emailNotification' style={styles.listItemRow}>
          <div style={styles.listItemTextWrapper}>
            <ListItemText
              primary='Delete Account'
              primaryTypographyProps={{ style: styles.listHeader }}
              secondary='Important Note: If you press this button, your account will be permanently deleted'
              secondaryTypographyProps={{ style: styles.listSubHeader }}
            />
          </div>
          <div style={styles.buttonWrapper}>
            <Button
              style={styles.buttonOrange}
              variant='contained'
              onClick={() => setIsDelete(true)}
            >
              Manage
            </Button>
          </div>
        </ListItem>
      </List>
      <CardActions />
    </>
  );
};

export default DeleteAccount;
